import React, { Component } from 'react';
import { isEmpty, size } from "lodash";
import {
    IconButton,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableFooter,
    TablePagination,
    Button,
    Box,
    Card,
    CardContent,
    Grid,
    Tooltip,
    Menu,
    MenuItem,
    TextField,
} from '@mui/material';
import Pagination from '../../../container/MUI/Pagination';
import IncomeForm from './IncomeForm';
import { Edit, AddCircle, Refresh, CloudDownloadRounded, EditRounded, DeleteRounded, CheckCircleRounded, FileCopyRounded, MoreVertRounded, FilterListRounded, ListAltRounded, DonutLargeOutlined, CloudUploadRounded, GetAppRounded } from '@mui/icons-material';
import ImportIncomesCSV from './ImportIncomesCSV';
import { InputSelectMulti, InputSelectNative } from '../../common/Form';
import { MONTHS } from '../../../utils/generalFuncs';
import { matchesDesc, parseAmount, inRange, sanitizeAmountInput } from '../../../utils/searchFilters';
import DeleteDialog from '../../common/DeleteDialog';
import Currency from '../../common/Currency';
import MatchingStatus from '../../common/MatchingStatus';
import { incomeMatchingState, incomeRemaining } from '../../../utils/matchingState';
import PostSingle from './PostSingle';
import BankSingle from '../Banks/BankSingle';
import IncomePayments from './IncomePayments';
import IncomeStats from './IncomeStats';
import SwipeableTabs from '../../../container/MUI/SwipeableTabs';
import PostsList from './PostsList';
import IncomeSingle from './IncomeSingle';
// import IncomeDetails from './IncomeDetails';

class IncomesList extends Component {
    state = {
        page: 0,
        rowsPerPage: 15,
        openDetails: false,
        openForm: false,
        openBank: false,
        selected: {},
        selectedPost: {},
        selectedBank: {},
        searchPayMode: "",
        searchMonth: "",
        searchYear: "",
        searchBank: {value: "", label: ""},
        searchPost: {value: "", label: ""},
        search: "",
        searchDesc: "",
        amountMin: "",
        amountMax: "",
        showFilters: false,
        anchorEl: null,
        openMenu: "",
        view: "list",
        showImportDialog: false,
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentWillMount() {
        window.scrollTo(0, 0);
    }
    componentDidMount = () => {
        if(isEmpty(this.props.INCOMES)){
            this.props.fetchIncomes()
        }   
        if(isEmpty(this.props.POSTS)){
            this.props.fetchPosts()
        }   
    }

    handleChange = (e) => {
        const { name, value } = e.target;

        this.setState({
            [name]: value,
            page: 0,
        })
    
    }
    handleSelect = (option, field) => {
        if(option){
            this.setState({                
                [field]: option,
                page: 0,
            })
        } else {
            this.setState({
                searchEmployee: {label: "", value: ""},
                page: 0,
            })

        }
    }
    filterList = () => {
        const { searchBank, searchPost, searchYear, searchMonth, searchPayMode, searchDesc, amountMin, amountMax} = this.state;
        const { INCOMES } = this.props
        
        let filteredList = Object.values(INCOMES)

        if (this.props?.projectID){
            filteredList = filteredList.filter( item => item.income_project                === this.props.projectID)
        }

        if( !isEmpty(searchPayMode)) {
            filteredList = filteredList.filter( item => item.income_payment_mode === searchPayMode)
        }
        
        if( !isEmpty(this.state.search)) {
      
            filteredList = filteredList.filter( item => item.income_id === this.state.search)
        }
      
        if( !isEmpty(searchBank.value)) {
            filteredList = filteredList.filter( item => item.income_bank === searchBank.value)
        }
        if( Array.isArray(searchBank) && !isEmpty(searchBank) ) {
            let itemList = searchBank.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(item.income_bank))
        }
        if( !isEmpty(searchPost.value)) {
            filteredList = filteredList.filter( item => item.income_post === searchPost.value)
        }
        if( Array.isArray(searchPost) && !isEmpty(searchPost) ) {
            let itemList = searchPost.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(item.income_post))
        }

        if( !isEmpty(searchMonth.value) ) {
            filteredList = filteredList.filter( item => new Date(item.income_date).getMonth() == searchMonth)
        } else if( Array.isArray(searchMonth) && !isEmpty(searchMonth)) {
            let itemList = searchMonth.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(new Date(item.income_date).getMonth()))
        } 

        if( searchYear ) {
            filteredList = filteredList.filter( item => new Date(item.income_date).getFullYear() == searchYear)
        }
        if( Array.isArray(searchYear) ) {
            let itemList = searchYear.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(new Date(item.income_date).getFullYear()))
        }

        const min = parseAmount(amountMin);
        const max = parseAmount(amountMax);
        if( searchDesc && searchDesc.trim() !== "" ) {
            filteredList = filteredList.filter( item => matchesDesc(item.income_desc, searchDesc))
        }
        if( min !== null || max !== null ) {
            filteredList = filteredList.filter( item => inRange(item.income_amount, min, max))
        }

        filteredList.sort((a, b) => {
            const dateA = new Date(a.income_date);
            const dateB = new Date(b.income_date);
            return dateB - dateA ; 
        });
        return filteredList
    }
    displayList = () => {
        const { INCOMES, POSTS, BANKS } = this.props;
        let tab = []
        let rows = 0

        if (!isEmpty(INCOMES) && !isEmpty(POSTS) && !isEmpty(BANKS) ){
            let filteredList = this.filterList()
            rows = size(filteredList)
            console.log({filteredList});
            tab.push( this.getIncomeList(filteredList))
        }
        return [tab, rows]
    }
    getIncomeList = (list) => {
        const { BANKS, POSTS } = this.props
        const { rowsPerPage, page, openMenu, anchorEl } = this.state;

            return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => {
                return (
                    <TableRow hover key={item.income_id} className="clickable"
                        // onClick={() => this.setState({ openDetails: true, selected: item })}    
                        // title="Voir le Détail"
                    >
                        <TableCell onClick={ () => this.setState({ openDetails: true, selected: item, openMenu: "",  anchorEl:null  }) } >
                            <MatchingStatus
                                state={incomeMatchingState(item)}
                                remaining={incomeRemaining(item)}
                            />
                        </TableCell>
                        <TableCell onClick={ () => this.setState({ openDetails: true, selected: item, openMenu: "",  anchorEl:null  }) } >{new Date(item.income_date).toLocaleDateString('fr-FR')}</TableCell>
                        <TableCell onClick={ () => this.setState({ openDetails: true, selected: item, openMenu: "",  anchorEl:null  }) } >
                            {item.income_desc}
                        </TableCell>
                        <TableCell 
                            onClick={() => this.setState({openPost: true, selectedPost: (item.income_post && POSTS[item.income_post]) }) }
                            className="a-like"
                        >
                            {item.income_post && POSTS[item.income_post].post_name}
                        </TableCell> 
                        <TableCell
                            onClick={() => this.setState({openBank: true, selectedBank: (item.income_bank && BANKS[item.income_bank]) }) }
                            className="a-like"
                        >
                            {item.income_bank && BANKS[item.income_bank].bank_name}
                        </TableCell>
                        <TableCell onClick={ () => this.setState({ openDetails: true, selected: item, openMenu: "",  anchorEl:null  }) } ><Currency value={item.income_amount} /></TableCell>
                        <TableCell onClick={ () => this.setState({ openDetails: true, selected: item, openMenu: "",  anchorEl:null  }) } >{item.income_payment_mode}</TableCell>
                        <TableCell>
                            <Tooltip title="Copier l'ID Facture" placement="left">
                                <IconButton 
                                    onClick={() => {
                                        navigator.clipboard.writeText(item.income_id); 
                                        this.setState({ copied : item.income_id })
                                    }} 
                                    color="secondary"
                                >
                                    {this.state.copied === item.income_id ? <CheckCircleRounded /> : <FileCopyRounded />}
                                </IconButton>
                            </Tooltip>
                        </TableCell>      
                        {/* <TableCell onClick={ () => this.setState({openUpdate: true, selected: item}) }>
                            <IconButton 
                                size="small" 
                                color="secondary"
                            >
                                <EditRounded />
                            </IconButton> 
                        </TableCell>      
                        <TableCell onClick={ () => this.setState({openDelete: true, selected: item}) }>
                            <IconButton 
                                size="small" 
                                color="secondary"
                            >
                                <DeleteRounded color="error"/>
                            </IconButton> 
                        </TableCell>       */}
                        <TableCell>
                            <IconButton 
                                aria-controls={`option-menu${item.income_id}`} 
                                aria-haspopup="true"
                                onClick={(event) => this.setState({ anchorEl: event.currentTarget, openMenu : item.income_id}) }>
                                <MoreVertRounded />
                            </IconButton>

                            <Menu
                                id={`option-menu${item.income_id}`}
                                anchorEl={anchorEl}
                                getContentAnchorEl={null}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={ openMenu === item.income_id}
                                onClose={() => this.setState({ openMenu: "", anchorEl: null})}
                            >
                                <MenuItem 
                                    onClick={ 
                                        () => this.setState({
                                            openUpdate: true,
                                            selected: item,
                                            openMenu: "", 
                                            anchorEl:null 
                                        }) 
                                    } 
                                >
                                    Modifier
                                </MenuItem>
                                <MenuItem 
                                    onClick={ 
                                        () => this.setState({
                                            openDelete: true,
                                            selected: item,
                                            openMenu: "", 
                                            anchorEl:null 
                                        }) 
                                    } 
                                >
                                    Supprimer
                                </MenuItem>
                            </Menu>
                        </TableCell>      
                    </TableRow>
                )
            })
    }

    downloadCSVTemplate = () => {
        const headers = "Date;Poste;Catégorie;Montant;Référence;Description;Mode de Paiement;Banque;Projet;Chantier";
        const blob = new Blob(["\uFEFF" + headers], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "template_import_recettes.csv";
        link.click();
        URL.revokeObjectURL(url);
    }

    handleClose = () => {
		this.setState({ 
            openDetails: false,
            openUpdate: false,
            openDelete: false,
            openPost: false,
            openBank: false,
            openForm: false,
            selected: {},
            selectedPost: {},
            selectedBank: {},
        });
    };    
    handleDelete = async () => {
        const { selected } = this.state;
        await this.props.deleteIncome(selected)
        if(this.props.STATE.incomes.error){
            this.props.notif("error", this.props.STATE.incomes.error)
        } else {
            this.props.notif("success", "Paiement supprimé")
            this.setState({
                openDelete: false,
                selected: {},
            })
        }
    }
    render() {
        const { INCOMES, BANKS, POSTS } = this.props;
        const { rowsPerPage, page, openForm, openDetails, selected, openDelete, openUpdate, openPost, selectedPost, openBank, selectedBank, showFilters, view } = this.state;
        let YEARS = []
        for (let year = 2019; year <= new Date().getFullYear(); year++) {
            YEARS.push(year)
        }
        console.log('==== STATE INCOME LIST ================================');
        console.log(this.state);
        console.log('====================================');
        let list = this.displayList()


        const ListRender = () => {
            return (
                <Box p={2}>
                <Typography variant="h6" id="tableTitle">
                    Liste des Recettes
                </Typography>

                <Box style={{display: "flex", justifyContent:"space-between"}}>
                    <Box>
                        <Button color="secondary" 
                            onClick={() => this.setState({ showFilters: !showFilters })} 
                            title="Afficher les filtres"
                            startIcon={<FilterListRounded />}
                        >
                            Filtres
                        </Button>
                    </Box>

                    {!(this.props?.listOnly) &&
                    <Box style={{textAlign: "right"}}>
                        <Button color="secondary"
                            onClick={() => this.setState({ showImportDialog: true })}
                            title="Importer des recettes depuis un CSV"
                            startIcon={<CloudUploadRounded />}
                        >
                            Importer CSV
                        </Button>
                        <Button variant="contained" color="secondary"
                            onClick={() => this.setState({ openForm: true })}
                            title="Nouvelle Recette"
                            startIcon={<AddCircle />}
                        >
                            Créer
                        </Button>
                        {/* {this.props.isSuper &&
                            <IconButton color="primary" onClick={this.props.recalcIncomes}>
                                <Refresh />
                            </IconButton>
                        } */}
                        <IconButton color="primary" onClick={() => this.props.openFormDownload("/extract/incomes")} title="Télécharger" disabled={this.props.downloading}>
                            <CloudDownloadRounded />
                        </IconButton>
                    </Box>
                    }
                </Box>
                {showFilters &&
                    <Card>
                    <CardContent>
                        <Grid container>
                            <Grid item xs={6}>
                                <InputSelectMulti
                                    label="Mois"
                                    name="searchMonth"
                                    onChange={(option) => this.handleSelect(option, "searchMonth")}
                                    value={this.state.searchMonth}
                                    id="searchMonth"
                                    options={MONTHS.map( (month, index) => ({
                                        label: month,
                                        value: index,
                                        disabled: Array.isArray(this.state.searchMonth) && !!this.state.searchMonth.find(element => element.value === index)
                                        
                                    })) }
                                    isMulti
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <InputSelectNative
                                    label="Année"
                                    name="searchYear"
                                    onChange={this.handleChange}
                                    value={this.state.searchYear}
                                    labelWidth={70} 
                                    id="searchYear"
                                    options={YEARS.map( year => (
                                        <option value={year} key={year}>
                                            {year}
                                        </option>
                                    )) }
                                />
                            </Grid>
                            
                            {!isEmpty(BANKS) && 
                                <Grid item xs={6}>
                                    <InputSelectMulti
                                        label="Banque"
                                        id="searchPost"
                                        options={Object.values(BANKS).map( item => ({
                                            label: `${item.bank_name}`,
                                            value: item.bank_id,
                                            disabled: Array.isArray(this.state.searchBank) && !!this.state.searchBank.find(element => element.value === item.bank_id)
                                            
                                        }))}
                                        value={this.state.searchBank}
                                        onChange={(option) => this.handleSelect(option, "searchBank")}
                                        isMulti
                                    />
                                </Grid>
                            }
                            {!isEmpty(POSTS) && 
                                <Grid item xs={6}>
                                    <InputSelectMulti
                                        label="Poste"
                                        id="searchPost"
                                        options={Object.values(POSTS).map( item => ({
                                            label: `${item.post_name}`,
                                            value: item.post_id,
                                            disabled: Array.isArray(this.state.searchPost) && !!this.state.searchPost.find(element => element.value === item.post_id)
                                            
                                        }))}
                                        value={this.state.searchPost}
                                        onChange={(option) => this.handleSelect(option, "searchPost")}
                                        isMulti
                                    />
                                </Grid>
                            }

                            <Grid item xs={12} sm={6} >
                                <InputSelectNative
                                    label="Mode de Paiement"
                                    name="searchPayMode"
                                    onChange={this.handleChange}
                                    value={this.state.searchPayMode}
                                    labelWidth={150} 
                                    options={[
                                        <option value="ESPECES">ESPECES</option>,
                                        <option value="CHEQUE">CHEQUE</option>,
                                        <option value="PRELEVEMENT">PRELEVEMENT</option>,
                                        <option value="VIREMENT">VIREMENT</option>,
                                        <option value="GAB">GAB</option>,
                                        <option value="MOBILE MONEY">MOBILE MONEY</option>,
                                        <option value="COLLAB">COLLAB</option>,
                                    ]}
                                />
                            </Grid>
                            <Grid item xs={6} style={{padding: 9}}>
                       
                                <TextField
                                    label="Recherche id"
                                    name="search"
                                    onChange={this.handleChange}
                                    value={this.state.search}
                                    fullWidth

                                />
                            </Grid>
                            <Grid item xs={12} sm={6} style={{padding: 9}}>
                                <TextField
                                    label="Description"
                                    name="searchDesc"
                                    value={this.state.searchDesc || ""}
                                    onChange={this.handleChange}
                                    fullWidth
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item xs={6} sm={3} style={{padding: 9}}>
                                <TextField
                                    label="Montant min"
                                    name="amountMin"
                                    value={this.state.amountMin || ""}
                                    onChange={(e) => { e.target.value = sanitizeAmountInput(e.target.value); this.handleChange(e); }}
                                    inputProps={{ inputMode: "decimal" }}
                                    fullWidth
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item xs={6} sm={3} style={{padding: 9}}>
                                <TextField
                                    label="Montant max"
                                    name="amountMax"
                                    value={this.state.amountMax || ""}
                                    onChange={(e) => { e.target.value = sanitizeAmountInput(e.target.value); this.handleChange(e); }}
                                    inputProps={{ inputMode: "decimal" }}
                                    fullWidth
                                    variant="outlined"
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                    </Card>
                }
                
                {!isEmpty(INCOMES) &&
                    <div className="table-responsive">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Pointage</TableCell>
                                    <TableCell>Créé le</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Poste</TableCell>
                                    <TableCell>Banque</TableCell>
                                    <TableCell>Montant</TableCell>
                                    <TableCell>Mode</TableCell>
                                    <TableCell>Copier ID</TableCell>
                                    <TableCell>Options</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {list[0]}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={[20, 30]}
                                        labelRowsPerPage="Lignes par Page"
                                        colSpan={9}
                                        count={list[1]}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        onPageChange={this.handleChangePage}
                                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                                        ActionsComponent={Pagination}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </div>
                }
                {this.state.showImportDialog &&
                    <ImportIncomesCSV
                        open={this.state.showImportDialog}
                        onClose={() => this.setState({ showImportDialog: false })}
                        POSTS={this.props.POSTS}
                        BANKS={this.props.BANKS}
                        CATEGORIES={this.props.CATEGORIES}
                        PROJECTS={this.props.PROJECTS}
                        CHANTIERS={this.props.CHANTIERS}
                        notif={this.props.notif}
                        fetchIncomes={this.props.fetchIncomes}
                        importIncomes={this.props.importIncomes}
                        deleteIncome={this.props.deleteIncome}
                    />
                }
            </Box>
            )
        }


        if (this.props?.listOnly){
            return ListRender()
        }

        return (
            <div>
                {openForm &&
                    <IncomeForm open={openForm} handleClose={this.handleClose} {...this.props} />
                }
                {openDetails && !isEmpty(selected) &&
                    <IncomeSingle
                        open={openDetails}
                        handleClose={this.handleClose}
                        {...this.props}
                        view="ADMIN"
                        income={selected}
                    />
                    // <IncomePayments open={openDetails} handleClose={this.handleClose} {...this.props} income={selected} />
                }
                {openUpdate && !isEmpty(selected) &&
                    <IncomeForm 
                        update 
                        income={selected} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                {openPost && !isEmpty(selectedPost) &&
                    <PostSingle 
                        post={selectedPost} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                        budget_year={this.state.searchYear}
                    />
                }
                {openBank && !isEmpty(selectedBank) &&
                    <BankSingle 
                        bank={selectedBank} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                        budget_year={this.state.searchYear}
                        income
                    />
                }
                {openDelete && !isEmpty(selected) &&
                    <DeleteDialog
                        title={"le Paiement"}
                        close={this.handleClose}
                        notif={this.props.notif}
                        handleSubmit={this.handleDelete}
                        disabledSubmit={this.props.STATE.incomes.fetching}
                    >
                        Paiement du {new Date(selected.income_date).toLocaleDateString("fr-FR")} - Montant: <Currency value={selected.income_amount} />
                    </DeleteDialog>
                }
                
                <Box
                    style={{textAlign: "right"}}
                >

                    <Button
                        color="primary"
                        startIcon={view === "stats" ? <ListAltRounded /> : <DonutLargeOutlined />}
                        onClick={() => this.setState({view: view === "stats" ? "list" : "stats"})}
                    >
                        {`${view !== "stats" ? "Stats": "Liste"}`}
                    </Button>
                </Box>
                {view === "stats" ?
                    <IncomeStats 
                        {...this.props}
                        {...this.state}
                    />
                :
                    <Box>

                         <SwipeableTabs
                            returnIndex={(index) => this.setState({ index })}
                            labels={["Recettes", "Postes"]}
                        >
                                {ListRender()}
                       
                            <Box p={2}>
                                <Typography variant="h6" id="tableTitle">
                                    Liste des Postes
                                </Typography>
                                <PostsList 
                                    {...this.props} 
                                />
                            </Box>
    
                        </SwipeableTabs>

                    </Box>
                }
            </div>
        );
    }
}

export default IncomesList;